(function () {
  const section = document.querySelector('[data-section-type="product"]');
  if (!section) return;

  const SECTION_ID  = section.dataset.sectionId;
  const PRODUCT_URL = section.dataset.productUrl || location.pathname.split('?')[0];

  const CONTAINER_SEL = '.product-detail__images-container';
  const THUMBS_SEL    = '.product-detail__thumbnails';
  const MAIN_SLIDER   = '.product-detail__images';
  const LABEL_SEL     = '[data-variant-label]';

  let currentVariant = new URLSearchParams(location.search).get('variant');
  let inFlight = false;

  ['pushState', 'replaceState'].forEach(function (type) {
    const orig = history[type];
    history[type] = function () {
      const ret = orig.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
      return ret;
    };
  });
  window.addEventListener('popstate', function () {
    window.dispatchEvent(new Event('locationchange'));
  });
  window.addEventListener('locationchange', handleVariantChange);

  function handleVariantChange() {
    const variant = new URLSearchParams(location.search).get('variant');
    if (!variant || variant === currentVariant || inFlight) return;
    currentVariant = variant;
    updateVariantGallery(variant);
  }

  async function updateVariantGallery(variantId) {
    inFlight = true;
    try {
      const url = PRODUCT_URL + '?variant=' + variantId + '&section_id=' + SECTION_ID;
      const res = await fetch(url);
      const markup = await res.text();
      const doc = new DOMParser().parseFromString(markup, 'text/html');

      const newContainer = doc.querySelector(CONTAINER_SEL);
      const newThumbs    = doc.querySelector(THUMBS_SEL);
      const newLabel     = doc.querySelector(LABEL_SEL);

      const oldContainer = section.querySelector(CONTAINER_SEL);
      const oldThumbs    = section.querySelector(THUMBS_SEL);
      const oldLabel     = section.querySelector(LABEL_SEL);

      const $ = window.jQuery;
      function grabOpts(sel) {
        const $el = $ && $(sel);
        return $el && $el.length && $el.hasClass('slick-initialized')
          ? $.extend(true, {}, $el.slick('getSlick').options)
          : null;
      }
      const mainOpts  = grabOpts(MAIN_SLIDER);
      const thumbOpts = grabOpts(THUMBS_SEL);

      if ($ && mainOpts)  $(MAIN_SLIDER).slick('unslick');
      if ($ && thumbOpts) $(THUMBS_SEL).slick('unslick');

      if (newContainer && oldContainer) oldContainer.replaceWith(newContainer);
      if (newThumbs && oldThumbs)       oldThumbs.replaceWith(newThumbs);
      if (newLabel && oldLabel)         oldLabel.replaceWith(newLabel);

      if ($) {
        if (mainOpts) {
          mainOpts.initialSlide = 0;
          $(MAIN_SLIDER).slick(mainOpts);
          $(MAIN_SLIDER).slick('slickGoTo', 0, true);
        }
        if (thumbOpts) {
          thumbOpts.initialSlide = 0;
          $(THUMBS_SEL).slick(thumbOpts);
          $(THUMBS_SEL).slick('slickGoTo', 0, true);
        }
      }
    } catch (e) {
      console.error('[variant-gallery] update failed', e);
    } finally {
      inFlight = false;
    }
  }

  // On first load: hide the gallery until it's on the first image, then fade in (no flash)
  function settleOnFirst() {
    const mainImages = section.querySelector(MAIN_SLIDER);
    if (!mainImages || mainImages.querySelector('[data-product-media]')) return;

    const layoutEl = section.querySelector('[data-product-image-layout]');
    const layout = layoutEl ? layoutEl.getAttribute('data-product-image-layout') : '';
    if (layout === 'list') return; // no slider, first image is already first

    if (!document.getElementById('vg-style')) {
      const st = document.createElement('style');
      st.id = 'vg-style';
      st.textContent =
        '.product-detail__images.vg-managed{opacity:0}' +
        '.product-detail__images.vg-managed.vg-ready{opacity:1;transition:opacity .2s ease}';
      document.head.appendChild(st);
    }
    mainImages.classList.add('vg-managed');

    let tries = 0;
    (function waitAndFix() {
      tries++;
      const $ = window.jQuery;
      const $main = $ && $(MAIN_SLIDER);
      if ($ && $main.length && $main.hasClass('slick-initialized')) {
        $main.slick('slickGoTo', 0, true);
        const thumbs = section.querySelectorAll(THUMBS_SEL + ' [data-product-media-thumbnail]');
        thumbs.forEach(function (t, i) { t.classList.toggle('thumb-active', i === 0); });
        mainImages.classList.add('vg-ready');
      } else if (tries < 180) {
        requestAnimationFrame(waitAndFix);
      } else {
        mainImages.classList.add('vg-ready');
      }
    })();
  }
  settleOnFirst();

  section.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-product-media-thumbnail]');
    if (!thumb) return;

    const mainImages = section.querySelector(MAIN_SLIDER);
    if (!mainImages || mainImages.querySelector('[data-product-media]')) return;

    e.preventDefault();
    e.stopPropagation();

    const thumbsWrap = thumb.closest(THUMBS_SEL);
    if (!thumbsWrap) return;
    const thumbs = Array.prototype.slice.call(thumbsWrap.querySelectorAll('[data-product-media-thumbnail]'));
    const index = thumbs.indexOf(thumb);
    if (index < 0) return;

    const $ = window.jQuery;
    const $main = $ && $(MAIN_SLIDER);
    if ($main && $main.length && $main.hasClass('slick-initialized')) {
      $main.slick('slickGoTo', index);
    } else {
      const slide = mainImages.querySelectorAll('.product-detail__image')[index];
      if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    thumbs.forEach(function (t) { t.classList.remove('thumb-active'); });
    thumb.classList.add('thumb-active');
  });
})();